<template>
    <ul class="files">
        <template v-for="file in filteredFiles">
            <li v-if="listStyle ==='pill'"  class="pill mr-2 mb-1">
                <a :href="file.aws_url" class="btn py-4px px-12px t-navy fs-14 lh-lg bg-grey border-radius-sm">{{file.filename}}</a>
            </li>
            <li v-else class="file row bg-white px-3 py-12px t-navy w-100">
                <div class="column p-0 file__name py-12px">{{file.filename}}</div>
                <div class="column p-0 pl-sm-2 file__date font-weight-light">{{formattedDate(file.created_at)}}</div>
                <div class="column p-0 file__btn text-sm-right">
                    <a :href="file.aws_url" target="_blank" class="btn btn-ghost bg-white">View</a>
                </div>
            </li>
        </template>
    </ul>
</template>

<script>
    import moment from "moment";

    export default {
        name: 'CatUxoFileList',
        components: {},
        props: {
            listStyle: {
                type: String,
                default: 'pill'
            },
            files: {
                type: Array,
                default: [],
                required: true
            }
        },
        methods: {
            formattedDate(date) {
                return moment(date, 'YYYY-MM-DD HH:mm:ss').format('Do MMMM YYYY');
            },
        },
        computed: {
            filteredFiles() {
                return this.files.filter(file => file.filetype === 'application/pdf' ||
                    file.filetype === 'text/csv' ||
                    file.filetype === 'text/plain' ||
                    file.filetype === 'application/msword' ||
                    file.filetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    file.filetype === 'application/vnd.ms-excel' ||
                    file.filetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            }
        },
        mounted() {
        }
    }
</script>


<style lang="scss" scoped>
    .file {
        &:nth-child(even) {
            background: $c-light-grey;
        }

        &:nth-child(odd) {
            background: $c-white;
        }
    }

    @include media-breakpoint-down(xs) {
        .file {
            flex-wrap: wrap;

            .column {
                flex-basis: auto;
            }

            &__name,
            &__total {
                width: 100%;
            }

            &__total {
                margin-bottom: rem(12px);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/FileList.vue